module.exports = __webpack_public_path__ + "img/chair-and-table-office-pc.58613d31.png";